import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import Loader from "../../components/Loader";
import Title from "../../components/Title";
import SocialMedia from "../../components/SocialMedia";
import titleline from "../../assets/images/webp/title_line.webp";
import seperator from "../../assets/images/webp/seperator.webp";
// import NoImage from "../../assets/images/webp/news-block.webp";
// import MoreArticleImage from "../../assets/images/webp/more-article.webp";
import moment from 'moment';
import NavClose from "../../assets/images/webp/nav_close.webp";
import MoreNewsIcon from "../../assets/images/webp/more-news-side-arrow.webp";

import { getNews, newsList } from "../../store/news/newsSlice";

const Index = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const { data, isLoader, newsData, newxtIndex } = useSelector(
    (state) => state?.news
  );

  useEffect(() => {
    dispatch(newsList());
  }, []);

  useEffect(() => {
    if (id) {
      dispatch(getNews(id));
    }
  }, [id]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const daysDifference = (date) => {
    var startDate = moment(date, "DD MMM yyyy");
    var endDate = moment( new Date(), "DD MMM yyyy");
    return endDate.diff(startDate, 'days');  
  }

  return (
    <>
      {isLoader && <Loader />}
        <section className="section-news">
      <Header type="news" />
      <div className="container-fluid p-0 pb-5">
        <div
          className="news-new-item news-details-img"
          style={{
            backgroundImage: "url(" + newsData.image + ")",
            padding: "300px 0",
          }}
        >
          <div className="container">
            <div className="row news-row position-absolute bottom-0">
              <div className="col-lg-5 my-auto">
                <div className="position-relative" style={{top :28}}>
                <Title text={newsData.title} />
                  <img src={titleline} alt="" width={"100%"} className="mt-0 position-relative" style={{bottom :15}} />
                  </div>
                <div className="row align-items-center">
                    <div className="col-md-7 col-7">{daysDifference(newsData?.date)} Days ago</div>
                 <div className="col-md-4 col-4">
                    <SocialMedia class1="w-75" top1={3} left1={5} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container pb-5">
        <div className="row">
          <div className="col-lg-8">
            <div className="news-section">

                 <div className="img-border-outside">
                    <div className="img-border-inside">
                     <img
                  className="img-fluid"
                  src={newsData.image}
                  alt={""}
                  // onError={(e) => e.target.src = NoImage}
                />
                    </div>
                  </div>
               
            </div>

            <div
              className="h4 mt-4"
              style={{ fontFamily: "Aesthetic Beauty CF", fontSize: 20 }}
              dangerouslySetInnerHTML={{ __html: newsData?.longDesc }}
            ></div>
<img src={titleline} alt="" width={"100%"} className="mt-4" />
            <div className="d-flex justify-content-between mt-4">
              <div className=" position-relative">
                <Link
                  to={`/news-details/${
                    data[newxtIndex - 1]
                      ? data[newxtIndex - 1]?._id
                      : data[0]?._id
                  }`}
                  className={`text-decoration-none gold-color news-pagination ${
                    data[newxtIndex - 1] ? "" : "disabled-link"
                  }`}
                >
                  <h3 className="mb-0">Previous</h3>
                </Link>
                <img src={titleline} alt="" width={"20%"} className="mt-0 position-relative" style={{right : 0, bottom:13}} />
              </div>

              <div className="text-end position-relative">
                <Link
                  to={`/news-details/${
                    data[newxtIndex + 1]
                      ? data[newxtIndex + 1]?._id
                      : data[0]?._id
                  }`}
                  className={`text-decoration-none gold-color  news-pagination-next ${
                    data[newxtIndex + 1] ? "" : "disabled-link"
                  }`}
                >
                  <h3 className="mb-0">Next</h3>
                <img src={titleline} alt="" width={"15%"} className="mt-0 position-relative" style={{right : 0, bottom:13}} />
                </Link>

              </div>
            </div>

              <div className="row  d-block d-lg-none">
                <div className="col-lg-12">
                <Link
                 to={`/news-details/${data[newxtIndex + 1] ? data[newxtIndex + 1]?._id : data[newxtIndex]?._id }`}
                className="text-decoration-none text-white"

              >
                <div className="mt-3">
                       <div className="news-section">
                        {/* <div className="news-box"> */}
                        <div className="col-item news-img-before">
                           <img className="img-fluid news-img"  src={data[newxtIndex + 1] ? data[newxtIndex + 1]?.image : data[newxtIndex]?.image} />
                          </div>
                          <div className="news-box-cont pb-0">
                            <h4 className="text-uppercase mb-2">
                              {data[newxtIndex + 1] ? data[newxtIndex + 1]?.title : data[newxtIndex]?.title}
                          </h4>
                    <img src={titleline} alt="" width={"100%"} className="mt-0 position-absolute" style={{left : 0, bottom:3}} />
                          </div>
                        {/* </div> */}
                      </div>
                    </div>
              </Link>
                </div>
                </div>

            <div className="mt-3 d-none d-lg-block">
              <div className="row">
                 {data.length > 0 &&
              data?.slice(newxtIndex+1,newxtIndex + 3).map((item, index) => {
                return (
                  <div className="col-lg-6" key={index}>
                    <Link
                      to={`/news-details/${item?._id}`}
                   
                      className="text-white"
                    >
                      <div className="news-section">
                        {/* <div className="news-box"> */}
                          <div className="col-item news-img-before">
                            <img
                              className="img-fluid news-img"
                              src={item.image}
                              alt={""}
                              // onError={(e) => e.target.src = NoImage}
                            />
                          </div>
                          <div className="news-box-cont pb-0">
                            <h4 className="text-uppercase mb-2">
                              {item.title}
                          </h4>
                    <img src={titleline} alt="" width={"100%"} className="mt-0 position-absolute" style={{left : 0, bottom:3}} />
                          </div>
                        {/* </div> */}
                      </div>
                    </Link>
                  </div>
                );
              })}
              </div>
            </div>
          </div>
          <div className="col-lg-1 col d-none d-lg-block">
            <div className=" news-sec-divider d-none d-lg-block"></div>
          </div>
          <div className="col-lg-3 col mb-4 d-none d-lg-block">
            <div className="text-center position-relative">
              <h3 className="mb-0">More News</h3>
              <img src={titleline} alt="" width={"50%"} className="mt-0 position-absolute" style={{left :"25%"}}/>
            </div>
            <div className="row mt-3">
              {data?.length > 0 &&
                data
                  ?.filter((val) => val?._id !== id)
                  ?.map((item, index) => (
                    <Link
                      to={`/news-details/${item?._id}`}
                      className="text-decoration-none text-white"
                      key={index}
                    >
                      <div className="col-lg-12 col-12">
                        <div className="news-section">
                          {/* <div className="news-box"> */}
                            <div className="col-item news-img-before">
                              <img
                                className="img-fluid news-img"
                                src={item?.image}
                                alt={""}
                                // onError={(e) => e.target.src = NoImage}
                              />
                            </div>
                          <div className="news-box-cont pb-0">
                            
                    <p className="mb-2">{item?.title}</p>
                    <img src={titleline} alt="" width={"100%"} className="mt-0 position-absolute" style={{left : 0, bottom:2}} />
                            
                            </div>
                        </div>
                        <div className="mt-2 mb-2 text-center">
              <img src={seperator} alt="" width={"50%"} className="mt-0 "/>

                        </div>
                        {/* </div> */}
                      </div>
                    </Link>
                  ))}
            </div>
          </div>
          <div className="social_media_sidebar d-block d-lg-none">
            <div className="SocialMediaSidebar_link">
               <img src={MoreNewsIcon}  className="img-fluid" width={32} onClick={handleShow} /> 
            </div>
          </div>
        </div>
        </div>
        </section>
      <Footer />
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement={"end"}
        responsive="lg"
        className="news-offcanvas d-block d-lg-none"
        id="offcanvasNewsResponsive"
      >
        <Offcanvas.Header>
          <button
            type="button"
            className="btn-close pt-0 m-0"
            onClick={handleClose}
            aria-label="Close"
          >
            <img src={NavClose} className="" width={20} height={20} alt="" />
          </button>
        </Offcanvas.Header>
        <Offcanvas.Body className="mb-5">
           <div className="text-center position-relative text-white mb-3">
              <h1 className="mb-0">More News</h1>
              <img src={titleline} alt="" width={"50%"} className="mt-0 position-absolute" style={{left :"25%", bottom:2}}/>
            </div>
          {/* <div className="meta-lord-text text-center mb-4">
            <h3 className="bg-golden-lt-news title2-text">More Article</h3>
          </div> */}
           <div className="row mt-3">
              {data?.length > 0 &&
                data
                  ?.filter((val) => val?._id !== id)
                  ?.map((item, index) => (
                    <Link
                      to={`/news-details/${item?._id}`}
                      className="text-decoration-none text-white"
                       onClick={handleClose}
                      key={index}
                    >
                      <div className="col-lg-12 col-12">
                        <div className="news-section">
                          {/* <div className="news-box"> */}
                            <div className="col-item news-img-before">
                              <img
                                className="img-fluid news-img"
                                src={item?.image}
                                alt={""}
                                // onError={(e) => e.target.src = NoImage}
                              />
                            </div>
                          <div className="news-box-cont pb-0">
                            
                    <p className="mb-2">{item?.title}</p>
                    <img src={titleline} alt="" width={"100%"} className="mt-0 position-absolute" style={{left : 0, bottom:2}} />
                            
                            </div>
                        </div>
                        <div className="mt-2 mb-2 text-center">
              <img src={seperator} alt="" width={"50%"} className="mt-0 "/>

                        </div>
                        {/* </div> */}
                      </div>
                    </Link>
                  ))}
            </div>
          {/* {data?.length > 0 &&
            data?.filter(val => val?._id !== id)?.map((item,index) => (
              <Link
                to={`/news-details/${item?._id}`}
                className="text-decoration-none text-white"
                onClick={handleClose}
                key={index}
              >
                <div className="recent-news-selection mb-4">
                  <div className="d-flex align-items-center">
                    <div className="recent-news-arrow"></div>
                    <div className="row align-items-center">
                      <div className="col-4">
                        <div className="recent-news-img mt-2 mb-2 mt-lg-0 mb-lg-0">
                          <img className="img-full" src={item?.image}
                      alt={""}
                            // onError={(e) => e.target.src = NoImage}
                          />
                        </div>
                      </div>
                      <div className="col-8">
                        <p className="date-text">{item?.date}</p>
                        <h5 className="title3-text bg-golden-lt">
                          {item?.title}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))} */}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Index;
